import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import rulePopout from 'components/triggers/RulePopout';
import SearchFieldActions from 'actions/triggers/SearchFieldActions';
import SearchFieldStore from 'stores/triggers/SearchFieldStore';
import FlatButton from 'components/pure/utils/FlatButton';
import SearchFieldSelection from 'components/triggers/search-field-selection/SearchFieldSelection';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import {FieldMatchingCondition} from 'records/CallTrigger';

class SearchFieldSelectionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedField: null,
      selectedOption: null,
    };

    this.selectedOptionChange = this.selectedOptionChange.bind(this);
    this.selectedFieldChange = this.selectedFieldChange.bind(this);

    this.saveSelection = this.saveSelection.bind(this);
  }

  selectedOptionChange(optionValue) {
    this.setState({
      selectedOption: optionValue,
    });
    const newContext = new FieldMatchingCondition({
      searchFieldId: this.state.selectedField,
      enumValue: optionValue,
    });
    this.props.updateSelection && this.props.updateSelection(newContext);
  }

  selectedFieldChange(fieldValue) {
    this.setState({
      selectedField: fieldValue,
      selectedOption: null,
    });
  }

  static getStores() {
    return [SearchFieldStore];
  }

  static getPropsFromStores() {
    const searchFieldStore = SearchFieldStore.getState();
    return {
      searchFields: searchFieldStore.searchFields,
      searchFieldsLoading: searchFieldStore.searchFieldsLoading,
      searchFieldsLoaded: searchFieldStore.searchFieldsLoaded,
    };
  }

  componentDidMount() {
    if (!this.props.searchFieldsLoaded && !this.props.searchFieldsLoading) {
      SearchFieldActions.fetchSearchFields();
    }

    this.setState({
      selectedField: this.props.selectedField,
      selectedOption: this.props.selectedOption,
    });
  }

  saveSelection() {
    const newContext = new FieldMatchingCondition({
      searchFieldId: this.state.selectedField,
      enumValue: this.state.selectedOption,
    });
    this.props.saveSelection(newContext);
  }

  render() {
    const canSave = !!this.state.selectedField && !!this.state.selectedOption;
    return (
      <div className="rule-select-popup">
        <SearchFieldSelection
          {...this.props}
          {...this.state}
          selectedFieldChange={this.selectedFieldChange}
          selectedOptionChange={this.selectedOptionChange}
        />
        <div className="selection-buttons">
          <button
            className={canSave ? 'save' : 'save disabled'}
            disabled={!canSave}
            onClick={() => this.saveSelection()}>
            <CheckIcon color={canSave ? 'white' : 'gray'} />
          </button>
          <FlatButton onClick={() => this.props.closeRequest('cancel')}>Cancel</FlatButton>
        </div>
      </div>
    );
  }
}

export default rulePopout(connectToStores(SearchFieldSelectionContainer));
